import { GlobalFilter } from "projects/shared/src/models/global/GlobalFilter";
import { SurveyResponsesSortEnum } from "./enums/SurveyResponsesSortEnum";

export class SurveyResponsesFilter extends GlobalFilter {
  taskId:number
  sort:SurveyResponsesSortEnum
}
